export default "__VITE_ASSET__Cwem6cx3__"